import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDesignationsList,
  createOrUpdateDesignation,
  deleteDesignation,
} from "./designationsThunks";

const designationsSlice = createSlice({
  name: "designations",
  initialState: {
    designations: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedDesignation: null,
    isEditDesignation: false,
  },
  reducers: {
    resetDesignationManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedDesignation: (state, action) => {
      state.selectedDesignation = action.payload;
    },
    setIsEditDesignation: (state, action) => {
      state.isEditDesignation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDesignationsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDesignationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.designations = action.payload;
      })
      .addCase(fetchDesignationsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createOrUpdateDesignation.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteDesignation.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const {
  resetDesignationManageStatus,
  setSelectedDesignation,
  setIsEditDesignation,
} = designationsSlice.actions;
export default designationsSlice.reducer;
